import { gql, TypedDocumentNode } from '@apollo/client';

import {
  UpdateOAuthConnectionMutation,
  UpdateOAuthConnectionMutationVariables,
} from '../generated';

export const UPDATE_OAUTH_CONNECTION: TypedDocumentNode<
  UpdateOAuthConnectionMutation,
  UpdateOAuthConnectionMutationVariables
> = gql`
  mutation UpdateOAuthConnection($input: UpdateOAuthConnectionInput!) {
    updateOAuthConnection(input: $input) {
      id
      provider
      providerAccountId
      description
      metadata
      scopes
      createdAt
      updatedAt
    }
  }
`;
